import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=f353e286&scoped=true&"
import script from "./leftMenu.vue?vue&type=script&lang=js&"
export * from "./leftMenu.vue?vue&type=script&lang=js&"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=f353e286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353e286",
  null
  
)

export default component.exports